import { useState } from "react";
import { Button } from "V2.0/common/button";
import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";

import useWebhookForm from "./useWebhookForm";
import WebhookForm from "./WebhookForm";

export default WebhookEditDialog;

function WebhookEditDialog(props) {
  const { onClose, webhook, onEditWebhookSave } = props;

  const { formState, updateFormState, validate, errors } =
    useWebhookForm(webhook);

  const [loading, setLoading] = useState<boolean>(false);

  const handleSave = () => {
    if (!validate()) {
      return;
    }

    const init = () => {
      setLoading(true);
      message.loading("Updating Webhook");
    };

    const success = () => {
      setLoading(false);
      message.destroy();
      message.success("Webhook Updated");
      onClose();
    };

    const error = (e: any) => {
      setLoading(false);
      message.destroy();
      showErrorToast(e, "Failed to Update Webhook");
    };

    onEditWebhookSave(webhook._id, formState, { init, success, error });
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>Update Webhook</DialogTitle>
      <DialogBody>
        <WebhookForm
          formState={formState}
          updateFormState={updateFormState}
          errors={errors}
        />
      </DialogBody>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          disabled={loading}
          onClick={handleSave}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
